import * as con from "../../GlobalConstants.js";

export const selectAllSurrogateUserTransactionsOk = (state) => {
  const status = state[con.REDUCER_SURROGATE_USERS_TRANSACTIONS][con.SURROGATE_TRANSACTIONS_LOADED];

  const requiredTypes = [
    con.EXPOSURES,
    con.COVERAGES_FWD,
    con.COVERAGES_SPOT,
    con.COVERAGES_OPTION,
    con.ACCOUNTS,
    con.MODEL_PARAMETERS
  ];

  return requiredTypes.every(
    type => status[type] === con.OK
  );
};